import { ComponentType } from "react";
import { loadRemote, registerRemotes } from "@module-federation/enhanced/runtime";
import { getRemote, Remote, RemoteEnvironment, RemoteRegion } from "@teamworksdev/web-sdk/module-federation";
import { createRemoteComponent } from "@module-federation/bridge-react";
import { RemoteAppContainerError } from "../../components/AppError/HubAppError";
import { Loading } from "../../shared-ui/global/Loading";
import { environment } from "../../environment";
import { useEnvironmentType } from "../../contexts/useEnvType";

const { isTactical } = useEnvironmentType();
const supportEmail = isTactical ? "tacsupport@teamworks.com" : "support@teamworks.com";

const loadAMSDashboard = ({ force }: { force?: boolean } = {}) => {
  // Register the remote
  const mfeEnvironment = environment.VITE_TW_MFE_ENV as RemoteEnvironment;
  const region = environment.VITE_REGION as RemoteRegion;

  if (!mfeEnvironment) throw new Error("VITE_TW_MFE_ENV environment variable is not set");
  if (!region) throw new Error("VITE_REGION environment variable is not set");

  registerRemotes([getRemote(mfeEnvironment, region, "ams-dashboard") as Remote], {
    force,
  });
  return loadRemote("ams_dashboard/ams_dashboard");
}

type AMSDashboardMFEProps = {
  category: string;
  locale: string;
  style?: React.CSSProperties;
};
// Create the remote component
const AMSDashboard = createRemoteComponent({
  loader: loadAMSDashboard,
  loading: <Loading />,
  fallback: ({ error }) => (
    <RemoteAppContainerError
      refresh={() => loadAMSDashboard({ force: true }).then(() => error)}
      failureHeader="Error: Page load failure"
      failureDescription={`We had some trouble loading the Dashboard. Please refresh the page or get in touch at ${supportEmail} if the problem persists.`}
    />
  ),
}) as unknown as ComponentType<AMSDashboardMFEProps>;


export const AMSDashboardMFE: ComponentType<AMSDashboardMFEProps> = ({ category, locale }) => {
  return (
    <AMSDashboard category={category} locale={locale} style={{ display: 'flex', flex: 1, width: '100%', height: '100%' }} />
  );
};
